import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import 'vuetify/styles'

// import {
// VDataTable, VExpansionPanels, VExpansionPanel, VExpansionPanelText, VExpansionPanelTitle, VAutocomplete, VDatePicker
// } from "vuetify/components";
// VDataTable, VExpansionPanels, VExpansionPanel, VExpansionPanelText, VExpansionPanelTitle, VDatePicker, VAutocomplete, VDateInput

const vuetify = createVuetify({
    components: {
        ...components,
        VTimePicker
    },
    directives: {
        ...directives
    },
    theme: {
        defaultTheme: 'light',
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
})

export default vuetify
